import axios from "axios";
import { API_URL } from "./const";

export interface NewsletterSubscribeData {
  email: string;
  language: string;
  // Where the signup happened (e.g. "blog:matching-turpak-sales", "blog_list").
  // Lets the backend attribute which content converts.
  source: string;
  // Honeypot: always empty for real users; a filled value flags a bot.
  website?: string;
}

class NewsletterService {
  /**
   * Register a double opt-in newsletter subscription. The backend stores the
   * address as `pending` and emails a confirmation link; nothing is subscribed
   * until that link is clicked.
   */
  subscribe(data: NewsletterSubscribeData) {
    return axios.post(API_URL + "newsletter/subscribe", data);
  }
}

const newsletterService = new NewsletterService();
export default newsletterService;
